import React, { ReactNode, forwardRef } from 'react';

import { APP_TOOLTIP_ID } from 'js/config/consts';

import EditPanelButton from './index';

type EditPanelButtonWithIconProps = {
  onClick: () => void;
  Icon: ReactNode;
  title?: string;
  dataTip?: string;
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export const EditPanelButtonWithIcon = forwardRef<HTMLButtonElement, EditPanelButtonWithIconProps>(
  ({ onClick, Icon, title, dataTip, ...rest }, ref) => {
    return (
      <span data-tip={dataTip} aria-label={dataTip} data-for={APP_TOOLTIP_ID}>
        <EditPanelButton onClick={onClick} {...rest} ref={ref}>
          <span className="EditPanelButton__icon-wrapper">
            <span className="EditPanelButton__icon">{Icon}</span>
            {!!title && <span className="EditPanelButton__icon-title">{title}</span>}
          </span>
        </EditPanelButton>
      </span>
    );
  }
);

EditPanelButtonWithIcon.displayName = 'EditPanelButtonWithIcon';
